import { productDataSelector } from '../selectors/SelectorUtils';
import { FETCH_BUNDLES_API_COMPLETED, FETCH_BUNDLES_API_FAILED, FETCH_BUNDLES_API_STARTED, FETCH_ELIGIBLE_ADDONS_API_COMPLETED, FETCH_ELIGIBLE_ADDONS_API_FAILED, FETCH_ELIGIBLE_ADDONS_API_STARTED, FETCH_PAGED_QUANTITY_PACKS_API_COMPLETED, FETCH_PAGED_QUANTITY_PACKS_API_FAILED, FETCH_PAGED_QUANTITY_PACKS_API_STARTED, FETCH_PER_PRODUCT_PRICING_API_COMPLETED, FETCH_PER_PRODUCT_PRICING_API_FAILED, FETCH_PER_PRODUCT_PRICING_API_STARTED, PLAN_BUILDER_INELIGIBLE_ADDONS_REMOVED, PLAN_BUILDER_INITIALIZATION_COMPLETE, PLAN_BUILDER_PRODUCT_CONFIGURATIONS_SORTED, PLAN_BUILDER_PRODUCT_LEVEL_FOR_PRODUCT_LINE_UPDATED, PLAN_BUILDER_QUANTITY_UPDATED, PLAN_BUILDER_SKU_REMOVED } from './constants/ActionTypes';
export const fetchBundlesApiStarted = () => {
  return {
    type: FETCH_BUNDLES_API_STARTED,
    payload: undefined
  };
};
export const fetchBundlesApiCompleted = payload => {
  return {
    type: FETCH_BUNDLES_API_COMPLETED,
    payload
  };
};
export const fetchBundlesApiFailed = () => {
  return {
    type: FETCH_BUNDLES_API_FAILED,
    payload: undefined
  };
};
export const fetchPerProductPricingApiStarted = () => {
  return {
    type: FETCH_PER_PRODUCT_PRICING_API_STARTED,
    payload: undefined
  };
};
export const fetchPerProductPricingApiCompleted = purchaseOption => {
  return {
    type: FETCH_PER_PRODUCT_PRICING_API_COMPLETED,
    payload: purchaseOption
  };
};
export const fetchPerProductPricingApiFailed = () => {
  return {
    type: FETCH_PER_PRODUCT_PRICING_API_FAILED,
    payload: undefined
  };
};
export const fetchPagedQuantityPacksApiStarted = () => {
  return {
    type: FETCH_PAGED_QUANTITY_PACKS_API_STARTED,
    payload: undefined
  };
};
export const fetchPagedQuantityPacksApiCompleted = payload => {
  return {
    type: FETCH_PAGED_QUANTITY_PACKS_API_COMPLETED,
    payload
  };
};
export const fetchPagedQuantityPacksApiFailed = () => {
  return {
    type: FETCH_PAGED_QUANTITY_PACKS_API_FAILED,
    payload: undefined
  };
};
export const planBuilderProductConfigurationsSorted = payload => {
  return {
    type: PLAN_BUILDER_PRODUCT_CONFIGURATIONS_SORTED,
    payload
  };
};
export const planBuilderInitializationComplete = payload => {
  return {
    type: PLAN_BUILDER_INITIALIZATION_COMPLETE,
    payload
  };
};
export const planBuilderQuantityUpdated = payload => {
  return {
    type: PLAN_BUILDER_QUANTITY_UPDATED,
    payload
  };
};
const planBuilderSkuRemoved = payload => {
  return {
    type: PLAN_BUILDER_SKU_REMOVED,
    payload
  };
};
export const planBuilderSkuRemovedThunk = ({
  skuId
}) => {
  return (dispatch, getState) => {
    const state = getState();
    const productData = productDataSelector(state);
    const hydratedPayload = {
      skuId,
      productData
    };
    dispatch(planBuilderSkuRemoved(hydratedPayload));
  };
};
const planBuilderProductLevelForProductLineUpdated = payload => {
  return {
    type: PLAN_BUILDER_PRODUCT_LEVEL_FOR_PRODUCT_LINE_UPDATED,
    payload
  };
};
export const planBuilderProductLevelForProductLineUpdatedThunk = ({
  productLine,
  productLevel
}) => {
  return (dispatch, getState) => {
    const state = getState();
    const productData = productDataSelector(state);
    const hydratedPayload = {
      productLine,
      productLevel,
      productData
    };
    dispatch(planBuilderProductLevelForProductLineUpdated(hydratedPayload));
  };
};
export const fetchEligibleAddonsStarted = () => {
  return {
    type: FETCH_ELIGIBLE_ADDONS_API_STARTED,
    payload: undefined
  };
};
export const fetchEligibleAddonsCompleted = payload => {
  return {
    type: FETCH_ELIGIBLE_ADDONS_API_COMPLETED,
    payload
  };
};
export const fetchEligibleAddonsFailed = () => {
  return {
    type: FETCH_ELIGIBLE_ADDONS_API_FAILED,
    payload: undefined
  };
};
export const planBuilderIneligibleAddonsRemoved = payload => {
  return {
    type: PLAN_BUILDER_INELIGIBLE_ADDONS_REMOVED,
    payload
  };
};